import React, { useEffect } from "react";
import HeadTitle from "../../Common/HeadTitle/HeadTitle";
import Cards from "./Cards";
import "./Gallery.css";
import GalleryData from "./GalleryData";

const Gallery = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <HeadTitle />

      <section className="gallery top">
        <div
          className="container grid"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 auto",
            gap: "20px",
            flexWrap: "wrap",
          }}
        >
          {GalleryData.map((value, index) => {
            return <Cards imgaes={value.img} key={index} title={value.title} />;
          })}
        </div>
      </section>
    </>
  );
};

export default Gallery;
